import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import '../theme/index.css';
import './utils/directives.js';
import 'babel-polyfill';
import Meta from 'vue-meta';
import './assets/fonts/iconfont.css'
Vue.use(Meta);

// TODO: 不做处理，判空会有问题
Vue.prototype.handleTableList = list => list;
// list.map(item => {
//     Object.keys(item).forEach(key => {
//         if (!item[key]) {
//             item[key] = '无'
//         }
//     })
//     return item
// });
//格式化金额函数
Vue.prototype.$formatAmount = function(amount) {
  return amount.toLocaleString('zh-CN');
};

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
